import { FC, useMemo } from "react";

import { ModalStatus } from "Types/modal";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { closeModal } from "Redux/modalSlice";
import { setMinimize } from "Redux/mapSlice";

import AddStation from "./AddStation";
import CreatePath from "./CreatePath";
import AddSurvay from "./AddSurvay";
// import StationTiming from "./StationTiming";

export interface IChildrenProps {
  closeModal: () => void;
  isOpen: boolean;
  modalData?: any;
}
interface IModal {
  id: ModalStatus;
  content: FC<IChildrenProps>;
}

const Modals: IModal[] = [
  { id: "add-station", content: AddStation },
  { id: "create-path", content: CreatePath },
  { id: "create-path", content: AddSurvay },
  // { id: "station-timing", content: StationTiming },
];

export default function ModalHandler() {
  const dispatch = useAppDispatch();
  const { status, data } = useAppSelector((state) => state.modal);

  const handleCloseModal = () => {
    dispatch(setMinimize(false));
    dispatch(closeModal());
  };

  const modals = useMemo(() => {
    return (
      <>
        {Modals.map((modal) => {
          const Content = modal.content;
          return <Content key={modal.id} closeModal={handleCloseModal} isOpen={status === modal.id} modalData={data} />;
        })}
      </>
    );
  }, [status, data]);

  return modals;
}
